import { render } from "./LogoWithText.vue?vue&type=template&id=123b13fc&scoped=true"
import script from "./LogoWithText.vue?vue&type=script&lang=js"
export * from "./LogoWithText.vue?vue&type=script&lang=js"

import "./LogoWithText.vue?vue&type=style&index=0&id=123b13fc&lang=css"
import "./LogoWithText.vue?vue&type=style&index=1&id=123b13fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123b13fc"]])

export default __exports__